import { render } from "./ErrorSpan.vue?vue&type=template&id=11c3caf7"
const script = {}

import "./ErrorSpan.vue?vue&type=style&index=0&id=11c3caf7&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__